import Cookies from "universal-cookie";
const cookies = new Cookies();

export function accessTokenSign(accessToken) {
  cookies.set("accessToken", accessToken, { path: "/", maxAge: 7800 });
}
